<template>
  <div class="btn-block">
    <ButtonDefault :buttonName="$t('shootings.showMore')" :loading="loading" @click="loadMore" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ButtonDefault from '../common/atoms/ButtonDefault.vue'
export default {
  components: {
    ButtonDefault
  },
  name: 'LoadMore',
  data() {
    return {
      loading: false,
      offset: 0
    }
  },
  computed: {
    ...mapGetters(['userId']),
    ...mapState({
      startDate: state => state.researchShooting.prev.startDate,
      endDate: state => state.researchShooting.prev.endDate,
      registration: state => state.researchShooting.prev.registration,
      types: state => state.researchShooting.prev.types
    })
  },
  methods: {
    async loadMore() {
      this.loading = true
      this.offset = this.$store.state.shootings.length
      const res = await this.$store.dispatch('loadMoreShootings', {
        userId: this.userId,
        offset: this.offset,
        startDate: this.startDate,
        endDate: this.endDate,
        registration: this.registration,
        types: this.types
      })
      this.$mam.shootingsSeeMore()
      if (res) this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.btn-block {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}
</style>
